export default __webpack_public_path__ + "static/media/mixinfibre.c54d1e3e.jpg";